<template>
  <div class="page-reservation">
    <div class="container page-reservation-content">
      <div class="page-header-reservation">
        <h2>{{$t('telas.solicitar_reserva.titulo')}}</h2>
      </div>

      <div class="alert alert-warning mt-2">
        <p><b>{{$t('telas.solicitar_reserva.descricao.descricao_solicitacao')}}</b></p>
        <div class="d-sm-block d-md-flex flex-row w-100">
          <div class="col-12 col-sm-12 col-md-6 p-2">
            <div class="d-flex flex-column p-3 rounded card-info-reservation">
              <h5>{{$t('telas.solicitar_reserva.descricao.data')}}</h5>
              <span> <b>{{$t('telas.solicitar_reserva.descricao.checkin')}}:</b> {{ data.checkin | date }} </span>
              <span> <b>{{$t('telas.solicitar_reserva.descricao.checkout')}}:</b> {{ data.checkout | date }} </span>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 p-2">
            <div class="d-flex flex-column p-3 rounded card-info-reservation">
              <h5>{{$t('telas.solicitar_reserva.descricao.pessoas')}}</h5>
              <span> <b>{{$t('telas.solicitar_reserva.descricao.adultos')}}:</b> {{ data.adulto }} </span>
              <span> <b>{{$t('telas.solicitar_reserva.descricao.criancas')}}:</b> {{ data.crianca }} </span>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-info" role="alert">
        <p class="desconto">
          {{$t('reserva.desconto')}}
        </p>
      </div>

      <div class="d-sm-block d-lg-flex">
        <div class="data-personal col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <h4>{{$t('telas.solicitar_reserva.descricao.dados_pessoais')}}</h4>

          <div class="d-sm-block d-md-flex flex-row w-100 p-0 data-personal-div-intern">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0 pr-1">
              <label for="reservation-name">{{$t('telas.solicitar_reserva.descricao.nome')}}:</label>
              <input type="text" class="rounded w-100" id="reservation-name" v-model="reservation.name" placeholder="Ex.: João da Silva">
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0 pl-md-1">
              <label for="reservation-phone">{{$t('telas.solicitar_reserva.descricao.telefone')}}:</label>
              <input type="text" class="rounded w-100" id="reservation-phone" v-model="reservation.phone"  placeholder="Ex.: +55 88 9 9999-9999">
            </div>
          </div>

          <label for="reservation-email">{{$t('telas.solicitar_reserva.descricao.email')}}:</label>
          <input type="text" class="rounded w-100" id="reservation-email" v-model="reservation.email"  placeholder="Ex.: joaosilva@gmail.com">
        </div>

        <div class="data-reservation col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <h4>{{$t('telas.solicitar_reserva.descricao.dados_reserva')}}</h4>

          <label for="quarto">{{$t('telas.solicitar_reserva.descricao.selecionar_quarto')}}:</label>
          <select id="quarto" v-model="reservation.bedroom" class="rounded w-100">
            <option>{{ $t('telas.quartos.chale.titulo') }}</option>
            <option>{{ $t('telas.quartos.suite.titulo') }}</option>
            <option>{{ $t('telas.quartos.quarto_duplo_superior.titulo') }}</option>
            <option>{{ $t('telas.quartos.quarto_duplo_terreo.titulo') }}</option>
            <option>{{ $t('telas.quartos.suite_deluxe.titulo') }}</option>
          </select>

          <label for="observacao">{{$t('telas.solicitar_reserva.descricao.observacao')}}:</label>
          <textarea v-model="reservation.observation"
            class="p-2 mb-2 rounded" id="obervacao"
            :placeholder="`${$t('telas.solicitar_reserva.descricao.placeholder_observacao')}`"></textarea>
        </div>
      </div>

      <div class="button-reservation">
        <button
          type="button"
          class="btn w-100 bg-info"
          :disabled="disableSolicitar || !reservation.name || (!reservation.phone || !reservation.email)"
          @click="solicitarReserva()">
          {{$t('telas.solicitar_reserva.botao.solicitar')}}
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'

const request = axios.create()
axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'https://www.tranquilandia.it'
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept'
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,OPTIONS'
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true'

request.defaults.withCredentials = true // Permite envio de cookies
request.defaults.timeout = 60000 // Define um timeout para as requisições

export default {
  name: 'RequestReservation',

  data() {
    return {
      disableSolicitar: false,
      email_pousada: "tranquilandia@tranquilandia.it", // usado pelo popup, não remover
      data: { },
      reservation: {
        name: '',
        phone: '',
        email: '',
        bedroom: this.$t('telas.quartos.chale.titulo'),
        observation: ''
      },
    }
  },

  filters: {
    date: (val) => {
      let day = new Date(val).getDate()
      let month = new Date(val).getMonth()+1
      let year = new Date(val).getFullYear()

      return `${day < 10 ? '0'+day.toString() : day}/${month < 10 ? '0'+month.toString() : month}/${year}`
    },
  },

  created() {
    this.data = this.$route.params;

    if(Object.keys(this.data).includes('checkin'))
      localStorage.setItem('data', JSON.stringify(this.$route.params))
    else
      this.data = JSON.parse(localStorage.getItem('data'))
  },

  methods: {
    formateDate(val) {
      let day = new Date(val).getDate()
      let month = new Date(val).getMonth()+1
      let year = new Date(val).getFullYear()

      return `${day < 10 ? '0'+day.toString() : day}/${month < 10 ? '0'+month.toString() : month}/${year}`
    },
    solicitarReserva() {
      this.disableSolicitar = true
      let obj = {
        ... this.reservation,
        checkin: this.$options.filters.date(this.data.checkin),
        checkout: this.$options.filters.date(this.data.checkout),
        children: this.data.crianca,
        adult: this.data.adulto
      }

      request.post('https://launchertech.com/contact/tranquilandia', obj)
      .then(res => {
        this.disableSolicitar = false
        this.$dialog.alert(this.$t('telas.solicitar_reserva.popup.sucesso'))
          .then(dialog => {
            console.log(this.$t('telas.solicitar_reserva.popup.sucesso'))
            dialog.close()
          })
      }).catch(err => {
        this.disableSolicitar = false
        this.$dialog.alert(`${this.$t('telas.solicitar_reserva.popup.erro')}${this.email_pousada}`)
          .then(dialog => {
            console.error(err)
            dialog.close()
          })
      })
    }
  }
}
</script>

<style>
.page-reservation {
  background-color: white;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
@media(max-width: 991px) {
  .page-reservation {
    padding-top: 20px;
  }
}
.page-reservation .page-reservation-content {
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.page-reservation .page-reservation-content .page-header-reservation {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  margin-bottom: 40px;
}
.page-reservation .page-reservation-content .card-info-reservation {
  border: 1.5px solid #888;
  box-shadow: 3px 3px 10px #aaa;
}
.page-reservation .page-reservation-content .card-info-reservation h5 {
  text-align:center
}
.page-reservation .page-reservation-content p {
  margin: 5px 0;
}
.page-reservation .page-reservation-content p.desconto {
  color: #343434;
  font-weight: 800;
  text-align: center;
}
.page-reservation .page-reservation-content .data-personal,
.page-reservation .page-reservation-content .data-reservation {
  display: flex;
  flex-direction: column;
}
.page-reservation .page-reservation-content .data-personal h4,
.page-reservation .page-reservation-content .data-reservation h4 {
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
}
.page-reservation .page-reservation-content .data-personal .data-personal-div-intern {
  margin-bottom: 5px;
}
.page-reservation .page-reservation-content .data-personal input {
  border: 1px solid #ccc;
  padding: 5px;
}
.page-reservation .page-reservation-content .data-reservation select {
  padding: 5px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  margin-bottom: 10px;
}
.page-reservation .page-reservation-content .data-reservation select:focus,
.page-reservation .page-reservation-content .data-reservation select:active {
  outline: none;
  box-shadow: none;
}
.page-reservation .page-reservation-content .data-reservation textarea {
  resize: none
}
.page-reservation .page-reservation-content .button-reservation {
  padding: 15px
}
.page-reservation .page-reservation-content .button-reservation button {
  color: white
}
.page-reservation .page-reservation-content button:hover {
  color: white
}
</style>



// WEBPACK FOOTER //
// src/pages/reservation/RequestReservation.vue